import { ApiFactory, type ApiDataResponse } from '@/utils/api';

/**
 * 登入 API
 */
export class TestService extends ApiFactory {
  constructor() {
    super('personal/test');
  }

  /**
   * 更新 Token
   */
  refreshToken(
    data: string
  ): Promise<ApiDataResponse<string>> {
    return super.getList(data);
  }
}
